/**
 * @format
 */

import {
  UPDATE_LIST_SUCCESS,
  UPDATE_LIST_FAILURE,
  UPDATE_LIST_OPTIMISTIC,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case UPDATE_LIST_OPTIMISTIC: {
      const { workspace_id, list_id, formData } = payload;

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: {
            ...(state.lists[workspace_id] || {}),
            [list_id]: {
              ...(state.lists[workspace_id]?.[list_id] || {}),
              ...formData, // optimistic update
            },
          },
        },
        listsLoadingMap: { ...state.listsLoadingMap, [list_id]: true },
        listsError: { ...state.listsError, [list_id]: null },
      };
    }

    case UPDATE_LIST_SUCCESS: {
      const { workspace_id, list } = payload;

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: {
            ...(state.lists[workspace_id] || {}),
            [list.id]: {
              ...(state.lists[workspace_id]?.[list.id] || {}),
              ...list, // confirmed update from server
            },
          },
        },
        listsLoadingMap: { ...state.listsLoadingMap, [list.id]: false },
      };
    }

    case UPDATE_LIST_FAILURE: {
      const { message, listId, prevList, workspace_id } = payload;

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: {
            ...(state.lists[workspace_id] || {}),
            [listId]: prevList, // rollback
          },
        },
        listsLoadingMap: { ...state.listsLoadingMap, [listId]: false },
        listsError: { ...state.listsError, [listId]: message },
      };
    }

    default:
  }
};
